export default __webpack_public_path__ + "static/media/unhallowedblight3.038cdb31.png";